import ProductWillBeAddedSoon from "../ProductWillBeAddedSoon";

const MonitorPage = () => {
  return <ProductWillBeAddedSoon />;
};

export default MonitorPage;
